import { ACTION_TYPES, ActionType, TemplateType } from "features/Resources/Shared/models";
import { ActionTypeTag } from "design-system";

interface TagByResourceTypeProps {
  type: ActionType | TemplateType;
}

function isTemplateType(type: ActionType | TemplateType) {
  return type.endsWith("_template");
}

export default function TagByResourceType({ type }: TagByResourceTypeProps) {
  if (!type) {
    return null;
  }
  if (isTemplateType(type)) {
    const actionType = (type as string).replace(/_template$/, "") as ActionType;
    return <ActionTypeTag.Badge actionType={actionType} />;
  } else if (ACTION_TYPES.includes(type as ActionType)) {
    return <ActionTypeTag.Badge actionType={type as ActionType} />;
  }
  return null;
}
